'use client';

import { c as _c } from "react/compiler-runtime";
import { usePrefetchGetCreatedMarketsAndProposals } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { useId, useState } from 'react';
import { AnimatedCountBadge } from '@/components/ui/animated-count-badge';
import { ChartRoseIconSolid, Rocket01IconSolid } from '@/components/ui/icon/glyphs';
import { Panel, PanelContent } from '@/components/ui/panel';
import { SegmentedControl } from '@/components/ui/segmented-control';
import { useViewportActivation } from '@/hooks/ui/use-viewport-activation';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { cn } from '@/lib/ui/utils';
import { CreatedMarkets, CreatedProposals } from './created-content-list';
export function CreatedPanel(t0) {
  const $ = _c(2);
  const {
    userId
  } = t0;
  const enabled = useFeatureGate("creator_and_platform_markets");
  if (enabled !== true) {
    return null;
  }
  let t1;
  if ($[0] !== userId) {
    t1 = <CreatedPanelContent key={userId} userId={userId} />;
    $[0] = userId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function CreatedPanelContent(t0) {
  const $ = _c(19);
  const {
    userId
  } = t0;
  const {
    ref,
    enabled,
    activate
  } = useViewportActivation();
  const t = useTranslations("profile.created");
  const tStats = useTranslations("profile.stats");
  const tFilter = useTranslations("markets.filter");
  const id = useId();
  const prefetchCreated = usePrefetchGetCreatedMarketsAndProposals();
  const [group, setGroup] = useState("markets");
  const [status, setStatus] = useState("trading,resolved,graduated");
  let t1;
  if ($[0] !== activate || $[1] !== group || $[2] !== id || $[3] !== prefetchCreated || $[4] !== status || $[5] !== t || $[6] !== tFilter || $[7] !== tStats || $[8] !== userId) {
    t1 = function renderControls(count, hasMore) {
      return <><div className="flex flex-wrap items-center justify-between gap-2"><div className="flex items-center gap-2"><h2 className="text-body-lg font-medium text-foreground-secondary">{t("title")}</h2>{count === undefined ? null : <AnimatedCountBadge value={count} hasMore={hasMore} />}</div><div className={cn("flex shrink-0", group === "proposals" && "invisible")} aria-hidden={group === "proposals"} inert={group === "proposals"}><SegmentedControl items={[{
              key: "trading,resolved,graduated",
              label: tFilter("all")
            }, {
              key: "trading",
              label: tStats("open_tab")
            }, {
              key: "resolved,graduated",
              label: tStats("closed_tab")
            }]} onItemPointerEnter={next => {
              if (next !== status) {
                prefetchCreated({
                  creatorUserId: userId,
                  group: "markets",
                  status: next,
                  sortOrder: "desc"
                });
              }
            }} active={status} onChange={next_0 => {
              activate();
              setStatus(next_0);
            }} layoutId={`${id}-status`} variant="chart-filled" asTabs={true} ariaLabel={t("statusLabel")} /></div></div><div className="-mx-4 min-w-0 overflow-x-auto px-4 scrollbar-none"><SegmentedControl items={[{
            key: "markets",
            label: t("markets"),
            icon: ChartRoseIconSolid
          }, {
            key: "proposals",
            label: t("proposals"),
            icon: Rocket01IconSolid
          }]} onItemPointerEnter={next_1 => {
            if (next_1 === group || next_1 !== "markets" && next_1 !== "proposals") {
              return;
            }
            prefetchCreated({
              creatorUserId: userId,
              group: next_1,
              ...(next_1 === "markets" ? {
                status
              } : {}),
              sortOrder: "desc"
            });
          }} active={group} onChange={value => {
            activate();
            if (value === "markets" || value === "proposals") {
              setGroup(value);
            }
          }} layoutId={`${id}-category`} variant="tab" indicatorClassName="bg-background-tertiary dark:bg-background-tertiary" asTabs={true} ariaLabel={t("title")} /></div></>;
    };
    $[0] = activate;
    $[1] = group;
    $[2] = id;
    $[3] = prefetchCreated;
    $[4] = status;
    $[5] = t;
    $[6] = tFilter;
    $[7] = tStats;
    $[8] = userId;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const renderControls = t1;
  let t2;
  if ($[10] !== enabled || $[11] !== group || $[12] !== renderControls || $[13] !== status || $[14] !== userId) {
    t2 = <PanelContent className="flex flex-col gap-4">{group === "markets" ? <CreatedMarkets userId={userId} enabled={enabled} status={status} sortOrder="desc" renderControls={renderControls} /> : <CreatedProposals enabled={enabled} userId={userId} sortOrder="desc" renderControls={renderControls} />}</PanelContent>;
    $[10] = enabled;
    $[11] = group;
    $[12] = renderControls;
    $[13] = status;
    $[14] = userId;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== ref || $[17] !== t2) {
    t3 = <Panel ref={ref} data-testid="portfolio-created">{t2}</Panel>;
    $[16] = ref;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}